import { render, staticRenderFns } from "./LayoutSingle.vue?vue&type=template&id=855f71b4"
import script from "./LayoutSingle.vue?vue&type=script&lang=js"
export * from "./LayoutSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports